import type { PriceAdjustmentType } from '@/types';

export interface AdjustmentItem {
  value: PriceAdjustmentType;
  label: string;
  /** Shown as a tooltip + inline badge when the adjustment is an approximation rather than an exact reset. */
  note?: string;
}

export const ADJUSTMENT_ITEMS: AdjustmentItem[] = [
  { value: 'splits',     label: 'Splits' },
  { value: 'div',        label: 'Dividends' },
  { value: 'div_script', label: 'Scrip Dividends' },
  {
    value: 'rights',
    label: 'Rights',
    note: 'Approximate — rights issues aren’t a guaranteed mechanical price reset like splits/dividends, so the adjusted price may not match the actual historical price.',
  },
];
